import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle2, Loader2, XCircle } from 'lucide-react';
import { API } from '@/utils/api';
import { CheckInBody } from '@/components/agenda/booking/CheckInDialog';

export default function MobileCheckInPage() {
  const [params] = useSearchParams();
  const [appt, setAppt] = useState(null);
  const [state, setState] = useState('loading');
  const [error, setError] = useState('');

  useEffect(() => {
    const t = params.get('t');
    if (t) sessionStorage.setItem('mobile_checkin_token', t);
    axios.get(`${API}/agenda/mobile-checkin/appointment`)
      .then(r => { setAppt(r.data); setState(r.data.checked_in ? 'done' : 'form'); })
      .catch(e => { setError(e.response?.status === 401 ? 'Lien expiré : générez un nouveau QR code depuis le bureau' : (e.response?.data?.detail || 'Lien invalide')); setState('error'); });
  }, [params]);

  return (
    <div className="min-h-screen bg-slate-100" data-testid="mobile-checkin-page">
      <header className="bg-[#0E1116] text-white px-4 py-3 border-b-4 border-[#FACC15]">
        <p className="text-xs uppercase tracking-widest text-[#FACC15] font-bold">Vortekio</p>
        <h1 className="text-lg font-bold">Réception du véhicule</h1>
      </header>
      <main className="p-4 max-w-lg mx-auto space-y-4">
        {state === 'loading' && <div className="flex justify-center py-16"><Loader2 className="w-8 h-8 animate-spin text-slate-400" /></div>}
        {state === 'error' && <div className="bg-white rounded-xl p-6 text-center space-y-2" data-testid="mobile-checkin-error"><XCircle className="w-10 h-10 text-red-500 mx-auto" /><p className="font-semibold">{error}</p></div>}
        {state === 'done' && (
          <div className="bg-white rounded-xl p-6 text-center space-y-2" data-testid="mobile-checkin-done">
            <CheckCircle2 className="w-12 h-12 text-emerald-600 mx-auto" />
            <p className="text-lg font-bold">Réception enregistrée</p>
            <p className="text-sm text-slate-600">Le bureau est mis à jour. Vous pouvez fermer cette page.</p>
          </div>
        )}
        {state === 'form' && appt && <div className="bg-white rounded-xl p-4 space-y-4"><CheckInBody appt={appt} mobile onDone={() => setState('done')} /></div>}
      </main>
    </div>
  );
}
